import { useQuery } from "@tanstack/react-query";
import api from "apis";
import { GetUserDayOffParams } from "apis/data-contracts";

const useUserDayOffQuery = (query: GetUserDayOffParams) => {
  return useQuery({
    queryKey: api.user.getUserDayOffKey(query),
    queryFn: () => api.user.getUserDayOff(query),
    select: (res) => res.data.result,
  });
};

export default useUserDayOffQuery;
